<template>
  <div id="wrapper">
    <transition name="page_loading_fade">
      <div class="page_loading" v-show="page_loading"></div>
    </transition>
    <div id="app">
        <headerItem/>
          <div id="contents_wrap">
            <router-view @page_fade="page_fade" @page_fade_true="page_fade_true" @change_op_flag_end="change_op_flag_end"/>
          </div><!-- #contents_wrap -->
          <p id="js-movie_banner" class="movie_banner"><a href="https://arikitarinakotobajyanakute.com/" target="_blank" rel="noopener"><img src="./assets/img/common/arikitarinakotobajyanakute_banner.jpg" alt="ありきたりな言葉じゃなくて" width="352" /></a></p>
        <footerItem/>
    </div>
  </div>
</template>



<script>
import headerItem from './components/common/headerItem'
import footerItem from './components/common/footerItem'

export default {
  name: 'App',
  data (){
    return {
      api_base_url: 'https://www.tv-asahipro.co.jp',
      // api_base_url: 'http://vivia.stg-malk.com',
      stg_api_base_url: 'http://vivia.stg-malk.com',
      op_movie: true,
      page_loading: true,
      page_load_time: 500,
      currnet: '',
      referrer: ''
    }
  },
  components: {
    headerItem,
    footerItem
  },
  watch: {
    '$route' (to, from) {
      this.createPageTitle(to)
      this.page_loading = true
      window.scrollTo(0,0)

      if(this.currnet != ''){
        this.referrer = this.currnet
        this.currnet = this.$route.name
      }else{
        this.currnet = this.$route.name
      }
    }
  },
  mounted () {
    // console.log(this.$route)
    let currentUrl = window.location.href;
    if (/sp\/#\//.test(currentUrl)) {
      let newUrl = currentUrl.replace(/sp\/#\//, 'sp/');
      window.location.href = newUrl;
    }
    var to = this.$route
    this.createPageTitle(to)
    $('#g_nav_list a').click(function(){
      $('#header_navbox').removeClass('active')
      $('.sp_menu_box').removeClass('active')
    })
    var movie_banner = document.getElementById('js-movie_banner');
    if (this.recruit_check()){
      $(movie_banner).css('display', 'none');
    }else{
      $(movie_banner).css('display', '');
    }
    $('#sp_menu').click(function(){
      var $target_box = $('#header_navbox');
      if(!$target_box.hasClass('active')){
        $target_box.addClass('active')
        $('.sp_menu_box').addClass('active')
      } else{
        $target_box.removeClass('active')
        $('.sp_menu_box').removeClass('active')
      }
      return false
    })
  },
  watch: {
    '$route' (to, from) {
      var movie_banner = document.getElementById('js-movie_banner');
      if (this.recruit_check()){
        $(movie_banner).css('display', 'none');
      }else{
        $(movie_banner).css('display', '');
      }
    }
  },
  methods:{
    page_fade: function(){
      if(['recruit_2025','recruit_2025_top'].includes(this.$route.name)){
        setTimeout(() => {
          this.page_loading = false
        }, 1500)
      } else {
        this.page_loading = false
      }
    },
    page_fade_true: function(){
      this.page_loading = true
    },
    change_op_flag_end: function(){
      this.op_movie = false
    },
    createPageTitle : function(to){
  		if(to.meta.title){
  			var setTitle = to.meta.title + ' | テレビ朝日映像';
  			document.title = setTitle;
  		} else {
  			document.title = 'テレビ朝日映像'
  		}
  		if(to.meta.desc){
  			var setDesc = to.meta.desc + ' | テレビ朝日映像';
  			document.querySelector("meta[name='description']").setAttribute('content', setDesc)
  		} else {
  			document.querySelector("meta[name='description']").setAttribute('content', '報道情報系番組をはじめ、ドキュメンタリー・バラエティ・ドラマなど幅広いテレビ番組制作とCM・企業VPなどの制作を行っています。各種イベントの運営業務、技術部門も手がける映像総合プロダクションです。')
  		}
    },
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024','recruit_2025','recruit_2025_application','recruit_2025_teaser','recruit_2025_top','recruit_2026','recruit_2026_application','recruit_2026_top'].includes(this.$route.name)
    }
  }//methods_end
}
</script>

<style>
  @import "./assets/stylesheet/vendor/animate.css";
</style>
<style lang="sass">
  @import "./assets/stylesheet/common.sass";
</style>
<style lang="sass">
  @import "./assets/stylesheet/style.sass";
</style>
<style lang="sass">
  .view-enter-active, view-leave-active
    transition: opacity 2s
  .view-leave-active
    position: absolute
  .view-enter, .view-leave-to
    opacity: 0
</style>



// WEBPACK FOOTER //
// src/App.vue